import React, { useCallback, useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import App from "@/App";
import Login from "@/components/Login";
import RegisterCompany from "@/components/RegisterCompany";
import AcceptInvite from "@/components/AcceptInvite";
import PaymentResult from "@/components/PaymentResult";
import ForgotPassword from "@/components/ForgotPassword";
import ResetPassword from "@/components/ResetPassword";
import ConnectFsm from "@/components/ConnectFsm";
import { getMe, refreshSession, logout as apiLogout } from "@/auth";

const Loading = () => (
  <div className="flex min-h-screen items-center justify-center bg-[#0a0e17] text-slate-400">
    <Loader2 className="mr-2 h-5 w-5 animate-spin" /> Loading…
  </div>
);

export default function Root() {
  const [status, setStatus] = useState("checking"); // checking | authed | anon
  const [user, setUser] = useState(null);

  const loadMe = useCallback(async () => {
    try {
      const u = await getMe();
      setUser(u); setStatus("authed");
    } catch (e) {
      if (e?.response?.status === 401) {
        try { await refreshSession(); const u = await getMe(); setUser(u); setStatus("authed"); return; } catch { /* fallthrough */ }
      }
      setUser(null); setStatus("anon");
    }
  }, []);

  useEffect(() => { loadMe(); }, [loadMe]);

  const onAuthed = () => loadMe();
  const onLogout = async () => {
    try { await apiLogout(); } catch { /* ignore */ }
    setUser(null); setStatus("anon");
  };

  if (status === "checking") return <Loading />;
  const authed = status === "authed";

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={authed ? <Navigate to="/" replace /> : <Login onAuthed={onAuthed} />} />
        <Route path="/register" element={authed ? <Navigate to="/" replace /> : <RegisterCompany onAuthed={onAuthed} />} />
        <Route path="/accept-invite" element={<AcceptInvite onAuthed={onAuthed} />} />
        <Route path="/forgot-password" element={authed ? <Navigate to="/" replace /> : <ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword onAuthed={onAuthed} />} />
        <Route path="/connect-fsm" element={<ConnectFsm />} />
        <Route path="/payment/success" element={<PaymentResult success />} />
        <Route path="/payment/cancel" element={<PaymentResult success={false} />} />
        <Route path="/*" element={authed ? <App user={user} onLogout={onLogout} refreshUser={loadMe} /> : <Navigate to="/login" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
